if (typeof WDN === 'undefined') {
  var WDN = {};
}


if (typeof WDN.StepPage === 'undefined') {
  WDN.StepPage = (function () {

    var List = {};

    var CustomEvent = {
      next: new Event('Page:next'),
      prev: new Event('Page:prev'),
      update: new Event('Page:update')
    };

    // Pre factory
    var Create = function (id, config) {
      if (!List[id] && config) {
        var item = document.querySelector(`.PageStep[data-id="${id}"]`);
        if (item) {
          List[id] = new Page(id, item, config);
        }
      }
    };

    // Factory
    var Page = function (id, item, config) {
      this.id = id;
      this.item = item;
      this.config = config;

      this.progress_bar = document.querySelector(`.PageStep__progress-container[data-id="${id}"]`);
      this.prevButton = document.querySelector(".PageStep__nav-item--prev");
      this.prevButton.addEventListener('click', this.prev.bind(this));
    }

    Page.prototype.activeStep = function () {
      return document.querySelector(`.PageStep__item[data-index="${this.config.index}"]`);
    };

    Page.prototype.next = function () {
      this.config.index = this.config.index + 1;
      this.navUpdate();
      this.item.dispatchEvent(CustomEvent.next);
    };

    Page.prototype.prev = function () {
      if (this.config.index > 1) {
        this.config.index = this.config.index - 1;
        this.navUpdate();
        this.item.dispatchEvent(CustomEvent.prev);
      }
    }

    Page.prototype.navUpdate = function () {
      this.item.dataset.index = this.config.index;
      
      if (this.progress_bar) {
        var parent = document.querySelector('.PageStep');
        
        var maxStep = parent.querySelectorAll('.PageStep__item').length;
        
        var width = (this.config.index / maxStep) * 100;
        
        this.progress_bar.querySelector('.PageStep__progress-bar').style.width = `${width}%`;
      }
      
      
      if (this.config.index != maxStep) {
        $(".PageStep__nav").removeClass('PageStep__nav--invisible');
      } else {
        $(".PageStep__nav").addClass('PageStep__nav--invisible');
      }
      
      if (this.config.index == 1) {
        $(".PageStep__nav").addClass('PageStep__nav--invisible');
      }
      
        this.item.dispatchEvent(CustomEvent.update);
    };

    return {
      Create: Create,
      List: List
    };

  })();
}





if (typeof WDN.Questionnaire === 'undefined') {
  WDN.Questionnaire = (function () {

    var init = function() {

      WDN.StepPage.Create('eksem', {
        index: 1,
        selections: [0]
      });

      var Nav = WDN.StepPage.List.eksem;

      var AnswerSum;

      var Classes = {
        answerList: 'PageStep__answer',
        answerActive: 'PageStep__answer--active'
      };

      var Selectors = {
        answerList: `.${Classes.answerList}`
      };

      var Items = {
        answerList: document.querySelectorAll(Selectors.answerList)
      };



      Items.answerList.forEach(function (answer) {

        answer.addEventListener('click', function () {

          Nav.activeStep().querySelectorAll(Selectors.answerList).forEach(function (item) {
            item.classList.remove(Classes.answerActive);
          });

          answer.classList.add(Classes.answerActive);

          if (answer.dataset.id !== 'welcome') {
            Nav.config.selections.push(parseInt(answer.dataset.answer));
            AnswerSum();
          } else {
            Nav.config.area = answer.dataset.answer;
          }
          Nav.next();
        });
      });

      var Factor = 0;

      AnswerSum = function () {
        var Nav = WDN.StepPage.List.eksem;
        // Get our results from each item
        var Sum = Nav.config.selections.map(function (item) {
          if (typeof item === 'number') {
            return item;
          } // Calculate the sum
        }).reduce(function (a, b) {
          return a + b;
        });


        if (Sum < 5) {
          Factor = 1;
        } else if (Sum <= 19) {
          Factor = 2;
        } else if (Sum <= 28) {
          Factor = 3;
        }

        Nav.config.resultNumber = Sum;
        Nav.config.resultFactor = Factor;
      };

      // Result page
      var ResultPage = {};

      ResultPage.label = function () {
        var resultLabel = document.querySelector("#Result");
        resultLabel.dataset.resultFactor = Factor;
      }

      ResultPage.products = function (category) {
        var productListParent = document.querySelector('.PageStep__products');
        var productListToShow = document.querySelector(`.PageStep__product-list[data-id="${category}"]`);

        if (productListToShow) {
          productListParent.classList.add('PageStep__products--active');
          productListToShow.classList.add('PageStep__product-list--visible');
        }
      };

      ResultPage.render = function () {
        ResultPage.label();
      };


      // Listen for next event on page sliders
      document.querySelector('.PageStep').addEventListener('Page:prev', function () {
        Nav.config.selections.pop();
      });

      document.querySelector('.PageStep').addEventListener('Page:next', function () {
        var parent = document.querySelector('.PageStep');
        var index = parent.dataset.index;
        var activeChild = parent.querySelector(`.PageStep__item[data-index="${index}"]`);
        parent.style.height = `${activeChild.clientHeight}px`;

        var items = parent.querySelectorAll('.PageStep__item').length;

        if (Nav.config.index === items) {
          ResultPage.render();
          ResultPage.products(Nav.config.area);
          document.querySelector('.PageStep__nav').remove();

          document.querySelector('#Result').dataset.resultFactor = Nav.config.resultFactor;

          // Send to GTM
          setTimeout(function () {
            document.querySelector('.PageStep__loader').classList.add('PageStep__loader--hidden');  
            var parent = document.querySelector('.PageStep');
            var index = parent.dataset.index;
            var activeChild = parent.querySelector(`.PageStep__item[data-index="${index}"]`);
            parent.style.height = `${activeChild.clientHeight}px`;
          }, 2000);
        }
      });

    }
    
    
    var _mount = function() {
      if (document.querySelector('.PageStep')) {
        init();
      }
    }
    
    
    _mount();
    
    
    return {
      init: init
    }

  })();
}

(function() {
  var questsToLoad = document.querySelectorAll('[data-article-test]');
  
  console.log(questsToLoad);

  questsToLoad.forEach(function(item) {
    var testId = item.dataset.articleTest;
    var endpoint = Quest.endpoints[testId];

    if (endpoint) {
      WDN.Request.Get({
        url: endpoint,
        onSuccess: function(r) {
          item.innerHTML = r;
          WDN.Questionnaire.init();
        },
        onError: function(e) {
          console.log(e);
        }
      });
    }
  });

})();